import React from 'react';
import { Grid, Cell } from 'react-md';
import BundleSummary from '../graphql/bundleSummary';
import Summary from '../components/Summary/Summary';
/* import Management from '../components/Management/Management'; */
import AttackCategories from '../components/AttackCategories/AttackCategories';
import MisconfigCategories from '../components/MisconfigCategories/MisconfigCategories';
import PercentCard from '../components/PercentCard/PercentCard';
import StarsCard from '../components/StarsCard/StarsCard';
import ChartCard from '../components/ChartCard/ChartCard';
import ToggleCard from '../components/ToggleCard/ToggleCard';
import ToggleAnimation from '../components/ToggleAnimation/ToggleAnimation';
import AlertSignupCard from '../components/AlertSignupCard/AlertSignupCard';
import MapLegend from '../components/MapLegend/MapLegend';
import ScrollButtons from '../components/ScrollButtons/ScrollButtons';
import { trackEvent } from '../util/analytics';
import {
  installGlobe,
  updateDots,
  updateAnimationToggle,
} from '../components/MapHalf/map-animation';
import '../components/MapHalf/MapHalf.scss';
import config from '../../site-config';

class Index extends React.Component {
  state = {
    toggleState: null,
    globeEnabled: true,
  };

  componentDidMount() {
    const { geo, cities } = this.props.data.bundleSummary;
    const { globeEnabled } = this.state;

    if (globeEnabled) {
      try {
        installGlobe(geo, cities);
      } catch (ex) {
        this.disableGlobe();
      }
    }
  }

  disableGlobe = () => this.setState({ globeEnabled: false });

  handleToggleChange(toggleState) {
    this.setState({ toggleState: toggleState });
    updateDots(toggleState);
  }

  handleToggleAnimation(animationOn) {
    updateAnimationToggle(animationOn);
    trackEvent({
      category: 'Globe',
      action: `Animation ${animationOn ? 'Enabled' : 'Disabled'}`,
    });
  }

  render() {
    const { toggleState, globeEnabled } = this.state;
    const bundleSummary = this.props.data.bundleSummary;
    const hasBundleSummary = bundleSummary && bundleSummary.length > 0;
    return (
      <div className="splitPane">
        <div className="left-panel" id="left-panel">
          <title>{config.siteTitle + ' - ' + bundleSummary.company}</title>
          <Grid className="main-grid" id="main-grid">
            <Cell size={12} className="summary-cell">
              <Summary bundleSummary={bundleSummary} />
            </Cell>
            {/* Commented out till we figure out how to better make use of this sharing feature */}
            {/* <Cell size={6} className="management-cell">
              <Management bundleSummary={bundleSummary} />
            </Cell>
            <Cell size={1}>
              <div />
            </Cell> */}
            <Cell size={12}>
              <StarsCard
                bundleSummary={bundleSummary}
                forceFiveStar={this.props.forceFiveStar}
              />
            </Cell>
            <Cell size={12}>
              <AlertSignupCard />
            </Cell>
            <Cell size={12}>
              <PercentCard bundleSummary={bundleSummary} />
            </Cell>
            {hasBundleSummary && (
              <Cell size={12}>
                <ChartCard
                  bundleSummary={bundleSummary}
                  toggleState={toggleState}
                />
              </Cell>
            )}
            {hasBundleSummary && (
              <Cell size={12}>
                <ToggleCard
                  bundleSummary={bundleSummary}
                  toggleCallback={this.handleToggleChange.bind(this)}
                />
              </Cell>
            )}
            <Cell size={12}>
              <AttackCategories bundleSummary={bundleSummary} />
            </Cell>
            <Cell size={12}>
              <MisconfigCategories bundleSummary={bundleSummary} />
            </Cell>
          </Grid>
          <ScrollButtons />
        </div>
        {globeEnabled && (
          <div className="right-panel globe js-globe">
            <ul className="globe-list js-list" />
            <canvas className="globe-canvas js-canvas" />
            <MapLegend />
            <ToggleAnimation
              handleToggleAnimation={this.handleToggleAnimation.bind(this)}
            />
          </div>
        )}
      </div>
    );
  }
}

export default Index;

export const pageQuery = graphql`
  query BundleQuery($bundle_id: String!) {
    bundleSummary(fields: { bundle_id: { eq: $bundle_id } }) {
      ...bundleSummary
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/index.jsx